export default __webpack_public_path__ + "static/media/wind_speed.9cb8e27d.svg";